export default {
    field: {
        maxWidth: 380,
        marginBottom: 0,
        marginTop: 30
    }
};
